document.addEventListener("DOMContentLoaded", () => {
  const stickyWrapper = document.querySelector("#etleeSizeSticky");
  if (!stickyWrapper) return;

  const sectionId = stickyWrapper.dataset.sectionId;
  const variantInput = document.querySelector(`#VariantId-${sectionId}`);
  const priceDisplay = document.querySelectorAll(`.PriceDisplay-${sectionId}`);
  const sizeOptions = stickyWrapper.querySelectorAll(".PDP-size-option");

  const allVariantImages = document.querySelectorAll(".variant-images");

  // === INIT ON LOAD ===
  if (variantInput && variantInput.value) {
    const activeOption = [...sizeOptions].find(
      o => o.dataset.variantId === variantInput.value
    );

    if (activeOption) {
      const defaultVariantTitle = activeOption.dataset.title.trim().toLowerCase();

      allVariantImages.forEach(group => {
        const handle = group.dataset.variant.toLowerCase();
        group.style.display = handle === defaultVariantTitle ? "block" : "none";
      });
    }
  }

  // === HANDLE VARIANT CLICK ===
  sizeOptions.forEach(option => {
    option.addEventListener("click", () => {
      sizeOptions.forEach(o => o.classList.remove("etlee-active"));
      option.classList.add("etlee-active");

      const variantId = option.dataset.variantId;
      const price = option.dataset.price;
      const variantTitle = option.dataset.title.trim().toLowerCase();

      variantInput.value = variantId;
      priceDisplay.forEach(o => (o.textContent = price));

      allVariantImages.forEach(group => {
        const groupHandle = group.dataset.variant.toLowerCase();
        group.style.display = groupHandle === variantTitle ? "block" : "none";
      });
    });
  });
});
